import styled from 'styled-components'

export const Wrapper = styled.div`
  .wrapper {
    min-height: 95px;
  }
`
